package ai.jessie.web.pages.organisations

import ai.jessie.web.invoices.unavailableInvoiceProblem
import ai.jessie.web.invoices.validInvoiceId
import ai.jessie.web.onboarding.organisationRequiredProblem
import ai.jessie.web.onboarding.validOrganisationId
import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext

// UC-013 step 11. An invalid invoice ID sends no request and shows the same neutral absence as an
// invoice outside the organisation (A8).
@Page("{organisationId}/invoices/{invoiceId}")
@Composable
fun organisationInvoicePage(ctx: PageContext) {
    val organisationId = ctx.route.dynamicParams["organisationId"].orEmpty()
    val invoiceId = ctx.route.dynamicParams["invoiceId"].orEmpty()
    when {
        !validOrganisationId(organisationId) ->
            invoiceProblemFrame(organisationId, organisationRequiredProblem())
        !validInvoiceId(invoiceId) ->
            invoiceProblemFrame(organisationId, unavailableInvoiceProblem())
        else -> key(organisationId, invoiceId) { invoicesContent(organisationId, invoiceId) }
    }
}
